import styles from './Checkbox.module.scss';

interface ICheckboxProps {
    checked: boolean;
    onChange: () => void;
}

export const Checkbox = ({ onChange, checked }: ICheckboxProps) => {
    return (
        <label className={styles.container}>
            <input className={styles.checkbox} type={'checkbox'} onChange={onChange} checked={checked} />
            <span className={styles.checkmark}></span>
        </label>
    );
};
